import { render, staticRenderFns } from "./TempHeader.vue?vue&type=template&id=f5c8f61e&scoped=true&"
import script from "./TempHeader.vue?vue&type=script&lang=js&"
export * from "./TempHeader.vue?vue&type=script&lang=js&"
import style0 from "./TempHeader.vue?vue&type=style&index=0&id=f5c8f61e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c8f61e",
  null
  
)

export default component.exports